var map = {
	"./error-page-404-zj.svg": 71065,
	"./error-page-404.svg": 44916,
	"./error-page-500-zj.svg": 66106,
	"./error-page-500.svg": 31153,
	"./error-page-503-zj.svg": 24283,
	"./error-page-503.svg": 10786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4025;